import * as TYPES from '@/store/types'

export default {

  [TYPES.CURRENT_LOCATION] (state, obj) {
    state.currentLocation = obj
  },
  [TYPES.LOCATION_BY_ID] (state, newLocation) {
    if (state.reportedLocations === null) {
      console.log('initialize reportedLocations')
      state.reportedLocations = { [newLocation.place_id]: newLocation }
    } else if (typeof (state.reportedLocations) === 'object') {
      console.log('looking up place_id:', newLocation.place_id)
      if (Object.keys(state.reportedLocations).includes(newLocation.place_id)) {
        console.log('location already known', newLocation.place_id)
      } else {
        console.log('adding new location', newLocation.place_id)
        let updatedLocations = Object.assign({[newLocation.place_id]: newLocation}, state.reportedLocations)
        console.log('updatedLocations:', updatedLocations)
        state.reportedLocations = updatedLocations
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/store/locations/mutations.js